import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './modules/dashboard'
import Goods from './modules/goods'
import Order from './modules/order'
import Account from './modules/account'
import Picker from './modules/picker'
import Settlement from './modules/settlement'
import Shop from './modules/shop'
import Invoice from './modules/invoice'
import Print from './modules/print'
import Layout from '@/layout'
import MarketService from './modules/marketService'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/pages/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login/index'),
    hidden: true,
    meta: { title: '登录' }
  },
  {
    path: '/auth-redirect',
    component: () => import('@/pages/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/pages/error_page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/pages/error_page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard'
  },
  {
    path: '/createdTemp/:platform/:shopId/:parentId/:id?',
    name: 'createdTemp',
    component: () => import('@/pages/marketService/createdTemp'),
    hidden: true,
    meta: { title: '创建模版', role: 1619 }
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  Dashboard,
  // Goods,
  Order,
  Picker,
  Account,
  Invoice,
  Settlement,
  Shop,
  Print,
  // MarketService,
  // add new router here
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
